import { Validator } from '@vista-digital/validator';
import { defaultOccFormFieldValidationConfig, occFormFieldValidationConfigValidator } from './form-field-validation';
export const defaultOccFormConfig = {
    enableFloatingInputLabels: false,
    fieldValidation: defaultOccFormFieldValidationConfig
};
export const occFormConfigValidator = Validator.object({
    enableFloatingInputLabels: Validator.boolean(),
    fieldValidation: occFormFieldValidationConfigValidator
});
